define(
    'views/global.view',[
        'loader',
        'config',
        'sandbox',
        'helper',

        'views/foundation.view',
        'views/awards.view',
        'views/breadcrumbs.view',
        'views/forum_description.view',
        'views/admin_notes.view',
        'views/admin_menu.view',
        'views/sortable_admin_forums.view',
        'views/topic_selector.view',
        // 'views/preview_style.view',
        'views/admin_advert_block.view',
        'views/highlight_code.view',
        'views/admin_index.view',
        'views/admin_options.view',
        'views/reports.view',
        'views/reputation.view',
        'views/admin_reports.view',
        'views/admin_awards.view',
        'views/mentions.view',
        'views/notifications.view'
    ],
    function(
        Loader,
        Config,
        Sandbox,
        Helper,

        FoundationView,
        AwardsView,
        BreadcrumbsView,
        ForumDescriptionView,
        AdminNotesView,
        AdminMenuView,
        // SortableAdminForumsView,
        TopicSelectorView,
        PreviewStyleView,
        AdminAdvertBlockView,
        HighLightCodeView,
        AdminIndexView,
        AdminOptionsView,
        ReportsView,
        ReputationView,
        AdminReportsView,
        AdminAwardsView,
        MentionsView,
        NotificationsView
        )
    {
        var $ = Loader.$;
        var _ = Loader._;

        var GameView = Loader.Backbone.View.extend({

            events: Helper.prepareEventsForDevice(
                {

                },
                Loader.eventType
            ),

            initialize: function() {

                _.bindAll(this, 'render');

                this.views =
                {
                    foundation:  new FoundationView.initialize(this.model),
                    awards:  new AwardsView.initialize(this.model),
                    breadcrumbs: new BreadcrumbsView.initialize(this.model),
                    forumDesc: new ForumDescriptionView.initialize(this.model),
                    adminNotes: new AdminNotesView.initialize(this.model),
                    adminMenuLink: new AdminMenuView.initialize(this.model),
                    // sortableAdminForumsLink: new SortableAdminForumsView.initialize(this.model),
                    topicSelector: new TopicSelectorView.initialize(this.model),
                    previewStyle: new PreviewStyleView.initialize(this.model),
                    adminAdvertBlock: new AdminAdvertBlockView.initialize(this.model),
                    highLightCodeView: new HighLightCodeView.initialize(this.model),
                    adminIndexView: new AdminIndexView.initialize(this.model),
                    adminOptionsView: new AdminOptionsView.initialize(this.model),
                    reportsView: new ReportsView.initialize(this.model),
                    ReputationView: new ReputationView.initialize(this.model),
                    adminReportsView: new AdminReportsView.initialize(this.model),
                    adminAwardsView: new AdminAwardsView.initialize(this.model),
                    mentionsView: new MentionsView.initialize(this.model),
                    notificationsView: new NotificationsView.initialize(this.model)
                };

                this.textareaResizer();

            },

            render: function() {

                var _this = this;
                _.each(this.views, function(view) {
                    view && view.render && view.render(true);
                });

                this.model.trigger('domReady');
                return this;
            },

            textareaResizer: function()
            {
                if (Config.modules.textareaResizer.enabled &&
                    document.location.href.indexOf('/admin_style.php')==-1)
                {
                    $('textarea:not(.processed)').TextAreaResizer();
                }
            }

        });



        return {
            initialize: function(model)
            {
                return new GameView(
                    {
                        model: model
                    });
            }
        }
    }
);

